import { render } from "./MultimidiaLeitura.vue?vue&type=template&id=63303156&scoped=true"
import script from "./MultimidiaLeitura.vue?vue&type=script&lang=js"
export * from "./MultimidiaLeitura.vue?vue&type=script&lang=js"

import "./MultimidiaLeitura.vue?vue&type=style&index=0&id=63303156&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63303156"]])

export default __exports__